import { useEffect, useState } from "react";
import { IndianRupee, ShoppingCart, Package, AlertTriangle } from "lucide-react";
import { api, rupee } from "@/lib/api";

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);
  useEffect(() => { api.get("/admin/stats").then((r) => setStats(r.data)).catch(() => {}); }, []);
  if (!stats) return <p className="text-muted-foreground">Loading…</p>;

  const cards = [
    { label: "Revenue (paid)", value: rupee(stats.revenue), icon: IndianRupee },
    { label: "Total Orders", value: stats.orders_count, icon: ShoppingCart },
    { label: "Products", value: stats.products_count, icon: Package },
    { label: "Low Stock", value: stats.low_stock.length, icon: AlertTriangle },
  ];

  return (
    <div>
      <h1 className="font-display text-2xl font-bold mb-6">Dashboard</h1>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
        {cards.map((c) => (
          <div key={c.label} className="bg-card border border-border rounded-2xl p-5" data-testid={`stat-${c.label}`}>
            <c.icon className="w-5 h-5 text-primary" />
            <p className="text-2xl font-bold font-mono mt-3">{c.value}</p>
            <p className="text-xs text-muted-foreground mt-1">{c.label}</p>
          </div>
        ))}
      </div>

      <div className="grid lg:grid-cols-2 gap-6">
        <div className="bg-card border border-border rounded-2xl p-5">
          <h2 className="font-semibold mb-4">Orders by Status</h2>
          {Object.keys(stats.status_counts).length === 0 ? <p className="text-sm text-muted-foreground">No orders yet.</p> :
            Object.entries(stats.status_counts).map(([k, v]) => (
              <div key={k} className="flex justify-between py-1.5 text-sm border-b border-border last:border-0">
                <span className="text-muted-foreground">{k}</span><span className="font-mono font-semibold">{v}</span>
              </div>
            ))}
        </div>
        <div className="bg-card border border-border rounded-2xl p-5">
          <h2 className="font-semibold mb-4 flex items-center gap-2"><AlertTriangle className="w-4 h-4 text-amber-500" /> Low Stock Alerts</h2>
          {stats.low_stock.length === 0 ? <p className="text-sm text-muted-foreground">All products well stocked.</p> :
            stats.low_stock.map((p) => (
              <div key={p.code} className="flex justify-between py-1.5 text-sm border-b border-border last:border-0">
                <span>{p.name} <span className="text-xs text-muted-foreground font-mono">{p.code}</span></span>
                <span className="font-mono text-amber-500">{p.stock} left</span>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
}
